(function() {
    // 注册组件
    SR.component.extend('theater', theater);

    var $body = SR.dom.$body;
    var $wrapper = SR.dom.$wrapper;
    var $historyWrapper = SR.dom.$historyWrapper;
    var $scrollWrap = SR.dom.$scrollWrap;
    var winH = SR.data.deviceInfo.height;
    var scrollAnimateDuration = SR.data.scrollAnimateDuration;
    var $theaterWrapper = $('<div class="theater-wrapper" id="theater-wrapper"></div>');
    var enterAnimateStyle = 'animated slideInLeft';
    var showAnimate = SR.state.isImmersive;
    var preTheaterH = $theaterWrapper.height();

    function theater() {
        var that = this;
        that.lineIndex = 0;

        SR.App.on('renderAnswer:theater', function() {
            that.lineIndex ++;
            if (that.lineIndex >= that.maxLineCount) {
                return;
            }
            next();
        });

        $body.on('click.theater', '.J_theater', function(e) {
            e.preventDefault();
            var $me = $(this);
            var action = $me.data('action');
            preTheaterH = $theaterWrapper.height();

            if($me.hasClass('triggered')) {
                return;
            }
            $me.addClass('triggered');

            switch(action) {
                case 'next':
                    that.lineIndex ++;
                    next();
                    break;
                case 'ask':
                    var question = $me.data('question');
                    window.ask(question, {
                        answerContainerId: 'theater-wrapper',
                        isTheater: true,
                        scrollToAnswer: false,
                    });
                    break;
                case 'exit':
                    $theaterWrapper.fadeOut(400);
                    setTimeout(function() {
                        $('#swiper-appearance').show();
                        $theaterWrapper.remove();
                        SR.state.categoryGuide && SR.component.slider();
                        $scrollWrap.scrollTop(10);  // 避免退出剧场模式后，第一个问题滑条定位的 BUG
                        $scrollWrap.scrollTop($historyWrapper.height() + (SR.state.hasHistory ? 21 : 0));
                    }, 400);
                    SR.component.guideQuestions();
                    break;
            }
        });
        
        this.play = function(script) {
            that.iScript = script;
            if (!that.iScript || !that.iScript.lines || !that.iScript.lines.length) {
                SR.state.categoryGuide && SR.component.slider();
                SR.component.guideQuestions();
                return;
            }
            $('#swiper-appearance').hide();
            that.maxLineCount = that.iScript.lines.length;
            $wrapper.append($theaterWrapper);
            next();
        }

        function next() {
            var lineIndex = that.lineIndex;
            $('.wrapper>.msg').remove();    // 清理原有问句，避免引起滑条定位错误
            // 读取台词
            var currentLine = that.iScript.lines[lineIndex];
            var lineDomId = 'lineId-' + Date.now();
            currentLine.id = lineDomId;
            var templateHTML = template('theater', currentLine);
            $theaterWrapper.append(templateHTML);
            var $line = $('#' + lineDomId);

            if (SR.state.isImmersive) {
                $('#' + lineDomId).addClass('hide');
                SR.util.enterAnimate($line, enterAnimateStyle + ' fastest');
            }

            scrollTimer = setTimeout(function() {
                // 滑动页面到当前回答位置
                var $currentDom = $('#' + lineDomId);
                if ($currentDom.length) {
                    var currentDomH = $currentDom.height();
                    var addContentH = $theaterWrapper.height() - preTheaterH;
                    addContentH = addContentH > winH ? winH : addContentH;
                    addContentH -= 81 + 41 + 15;
                    var scrollTop = $scrollWrap.scrollTop() + addContentH;

                    if (SR.state.hasHistory) {
                        scrollTop = scrollTop < 20 ? 20 : scrollTop;
                    }

                    if (scrollTop > 0) {
                        $scrollWrap.stop(false, true).animate({
                            scrollTop: scrollTop
                        }, scrollAnimateDuration);
                    }
                }
            }, 100);
        }
    }
})();
